import React from 'react';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
import { NOTIFICATIONS_INDENT } from "../constants";
var cnNotificationsMapper = cnBem('notifications-mapper', styles);
export var NotificationsMapper = function NotificationsMapper(_ref) {
  var notifications = _ref.notifications,
    children = _ref.children,
    topItemHeight = _ref.topItemHeight,
    expanded = _ref.expanded;
  var height = topItemHeight + NOTIFICATIONS_INDENT;
  if ((notifications === null || notifications === void 0 ? void 0 : notifications.length) < 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: cnNotificationsMapper({
      expanded: expanded
    }, ['list']),
    style: {
      height: expanded ? 'auto' : height
    },
    "data-t-id": "Notifications-NotificationsMapper"
  }, notifications.map(function (notification, index) {
    return children({
      notification: notification,
      index: index
    });
  }));
};